<template>
    <!--<v-card>-->
        <!--<v-card-title primary-title>-->
            <!--<div class="headline">{{profile.name}}</div>-->
            <!--<div>{{ profile.description }}</div>-->
        <!--</v-card-title>-->
        <!--<v-card-actions>-->
            <!--<v-btn flat>Listen now</v-btn>-->
        <!--</v-card-actions>-->
    <!--</v-card>-->

    <v-card @click="$emit('select')">
        <v-card-media class="text-xs-center">
            <img :src="provider.Logo"
                 style="max-width:100px; max-height: 100px; margin: 20px;">
        </v-card-media>
        <v-card-actions class="white">
            <span>{{ provider.Name }}</span>
            <v-spacer></v-spacer>
            <v-btn icon>
                <v-icon>compare_arrows</v-icon>
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
//    import { mapGetters } from 'vuex';
//    import { NAV_SIDEBAR, AUTH_LOGOUT } from '../store/mutations';

    export default {
        name: 'profile-provider-card',
        props: ['provider'],
        data() {
            return {};
        },
        methods: {
//            toggleSidebar() {
//                this.$store.commit(NAV_SIDEBAR, !this.$store.state.nav.sidebar);
//            },
//            signOut() {
//                this.$store.commit(AUTH_LOGOUT);
//                this.$router.push({ path: '/login' });
//            },
        },
    };
</script>



// WEBPACK FOOTER //
// ProfileProviderCard.vue?1069cb13